import { render, staticRenderFns } from "./PlanActionOverview.vue?vue&type=template&id=12229a28&scoped=true&"
import script from "./PlanActionOverview.vue?vue&type=script&lang=js&"
export * from "./PlanActionOverview.vue?vue&type=script&lang=js&"
import style0 from "./PlanActionOverview.vue?vue&type=style&index=0&id=12229a28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12229a28",
  null
  
)

export default component.exports